import * as DeliveryFeeConstants from "../constants/delivery.constant";
import { deleteItemHelper } from "../utils/helpers/dataHelper";

const initialState = {
  deliveryFeeList: [],
  deliveryFee: {},
  deliveryFeeLoading: false,
  modalOpen: false,
  stationNames: [],
  stationNamesLoading: false,
  deleteStatusState: false,
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.deliveryFeeLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const deliveryFeeReducer = (state = initialState, action) => {
  const currentDeliveryFeeList = [...state.deliveryFeeList];
  switch (action.type) {
    case DeliveryFeeConstants.ADD_DELIVERY_FEE_REQUEST:
      return { ...state, deliveryFeeLoading: true };
    case DeliveryFeeConstants.ADD_DELIVERY_FEE_SUCCESS:
      return {
        ...state,
        deliveryFee: action.payload.data,
        deliveryFeeLoading: false,
      };
    case DeliveryFeeConstants.ADD_DELIVERY_FEE_FAILURE:
      return { ...state, deliveryFeeLoading: false };

    case DeliveryFeeConstants.GET_ALL_DELIVERY_FEE_REQUEST:
      return { ...state, deliveryFeeLoading: true };
    case DeliveryFeeConstants.GET_ALL_DELIVERY_FEE_SUCCESS:
      return {
        ...state,
        deliveryFeeList: action.payload.data,
        deliveryFeeLoading: false,
      };
    case DeliveryFeeConstants.GET_ALL_DELIVERY_FEE_FAILURE:
      return { ...state, deliveryFeeLoading: false };

    case DeliveryFeeConstants.GET_DELIVERY_FEE_REQUEST:
      return { ...state, deliveryFeeLoading: true };
    case DeliveryFeeConstants.GET_DELIVERY_FEE_SUCCESS:
      return {
        ...state,
        deliveryFee: action.payload.data,
        deliveryFeeLoading: false,
      };
    case DeliveryFeeConstants.GET_DELIVERY_FEE_FAILURE:
      return { ...state, deliveryFeeLoading: false };

    case DeliveryFeeConstants.DELETE_DELIVERY_FEE_REQUEST:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };
    case DeliveryFeeConstants.DELETE_DELIVERY_FEE_SUCCESS:
      const newList = deleteItemHelper(
        currentDeliveryFeeList,
        action.payload.id,
        "id"
      );
      return {
        ...state,
        deliveryFeeList: newList,
        deleteStatusState: setLoading(state, action),
      };
    case DeliveryFeeConstants.DELETE_DELIVERY_FEE_FAILURE:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };

    case DeliveryFeeConstants.UPDATE_DELIVERY_FEE_REQUEST:
      return { ...state, deliveryFeeLoading: true };
    case DeliveryFeeConstants.UPDATE_DELIVERY_FEE_SUCCESS:
      return {
        ...state,
        deliveryFee: action.payload.data,
        deliveryFeeLoading: false,
      };
    case DeliveryFeeConstants.UPDATE_DELIVERY_FEE_FAILURE:
      return { ...state, deliveryFeeLoading: false };

    case DeliveryFeeConstants.GET_DELIVERY_STATIONS_REQUEST:
      return { ...state, stationNamesLoading: true };
    case DeliveryFeeConstants.GET_DELIVERY_STATIONS_SUCCESS:
      return {
        ...state,
        stationNames: action.payload.data,
        stationNamesLoading: false,
      };
    case DeliveryFeeConstants.GET_DELIVERY_STATIONS_FAILURE:
      return { ...state, stationNamesLoading: false };

    default:
      return state;
  }
};

export default deliveryFeeReducer;
